/**
 * JJ&S Section Scroll Tracker
 * Fires GA4 `section_viewed` events via GTM dataLayer
 * when each Shopify section first enters the viewport.
 * Deployed: 2026-06-08
 */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;

  var fired = new Set ? new Set() : { _s: [], has: function(v){ return this._s.indexOf(v) > -1; }, add: function(v){ this._s.push(v); } };

  // ?? Page type ??????????????????????????????????????????????????????????????
  function getPageType() {
    if (window.Shopify && window.Shopify.template) return window.Shopify.template;
    var p = window.location.pathname;
    if (p === '/' || p === '') return 'home';
    if (p.indexOf('/products/') === 0) return 'product';
    if (p.indexOf('/collections/') === 0) return 'collection';
    if (p.indexOf('/pages/') === 0) return 'page';
    if (p.indexOf('/blogs/') === 0) return 'blog';
    if (p.indexOf('/cart') === 0) return 'cart';
    if (p.indexOf('/checkout') === 0) return 'checkout';
    return 'other';
  }

  // ?? Convert kebab-id ? Title Case label ???????????????????????????????????
  var LABEL_MAP = {
    'main-product':              'Product Main',
    'main-collection-product-grid': 'Collection Grid',
    'main-collection-header':   'Collection Header',
    'main-search':               'Search Results',
    'main-cart-items':           'Cart Items',
    'main-cart-footer':          'Cart Footer',
    'main-article':              'Blog Article',
    'main-blog':                 'Blog Index',
    'main-page':                 'Page Content',
    'main-404':                  '404 Page',
    'header':                    'Site Header',
    'footer':                    'Site Footer',
    'related-products':          'Related Products',
    'usps':                      'USP Bar',
    'instagram-feed':            'Instagram Feed',
    'ba2-hero':                  'Hero Banner',
    'ba2-featured-products':     'Featured Products',
    'ba-featured-products':      'Featured Products',
    'ba-reviews':                'Reviews',
    'ba-by-age':                 'Shop By Age',
    'ba-awards':                 'Awards',
    'ba-hero-banner':            'Hero Banner',
    'ba-promos':                 'Promotions',
    'ba-features':               'Features',
    'ba-columns-flex':           'Column Layout',
    'landing-products':          'Products Block',
    'landing-collections':       'Collections Block',
    'landing-blog-posts':        'Blog Posts',
    'landing-brand-values':      'Brand Values',
    'landing-image-banner':      'Image Banner',
    'landing-intro':             'Intro Text',
    'landing-text':              'Text Block',
    'landing-ugc':               'UGC / Reviews',
    'landing-video-slider':      'Video Slider',
    'landing-image-slider':      'Image Slider',
    'jjs-lp-hero-v1':            'LP Hero V1',
    'jjs-lp-hero-v2':            'LP Hero V2',
    'jjs-lp-hero-vgem':          'LP Hero VGem',
    'jjs-lp-hero-plain':         'LP Hero Plain',
    'jjs-lp-body-v1':            'LP Body V1',
    'jjs-lp-body-v2':            'LP Body V2',
    'jjs-lp-carousel-vgem':      'LP Product Carousel',
    'jjs-lp-sale-hero':          'Sale Hero',
    'jjs-lp-sale-grid':          'Sale Grid',
    'jjs-lp-social-strip-v1':    'Social Proof Strip',
    'lp-product-hero':           'LP Product Hero',
    'lp-product-hero-hormozi':   'LP Product Hero (Hormozi)',
    'lp-hormozi-body':           'LP Body (Hormozi)',
    'lp-reviews':                'LP Reviews',
    'lp-faq':                    'LP FAQ',
    'lp-offer-block':            'LP Offer Block',
    'lp-why-this':               'LP Why This',
    'lp-in-the-box':             'LP In The Box',
    'lp-comparison-table':       'LP Comparison Table',
    'lp-heritage-close':         'LP Heritage Close',
    'lp-how-parents-use-it':     'LP How Parents Use It',
    'lp-sticky-bar':             'LP Sticky Bar',
    'lp-products-carousel':      'LP Products Carousel',
    'ugc':                       'UGC Block',
    'related-articles':          'Related Articles'
  };

  function toTitleCase(str) {
    return str.replace(/-/g, ' ').replace(/\b\w/g, function(c){ return c.toUpperCase(); });
  }

  function getSectionLabel(el) {
    // 1. Explicit override attribute wins
    var override = el.getAttribute('data-section-label');
    if (override) return override;

    // 2. Strip the shopify-section- prefix
    var raw = (el.id || '').replace(/^shopify-section-/, '');

    // 3. Look up friendly name
    if (LABEL_MAP[raw]) return LABEL_MAP[raw];

    // 4. Identify LP body sections by prefix
    if (raw.indexOf('jjs-lp-body-') === 0) return 'LP Body: ' + toTitleCase(raw.replace('jjs-lp-body-', ''));
    if (raw.indexOf('jjs-influencer-') === 0) return 'Influencer: ' + toTitleCase(raw.replace('jjs-influencer-', ''));

    // 5. Fall back to title-cased id
    return raw ? toTitleCase(raw) : 'Unknown Section';
  }

  // ?? Observer ???????????????????????????????????????????????????????????????
  var pageType = getPageType();
  var allSections = Array.prototype.slice.call(document.querySelectorAll('.shopify-section'));

  if (!allSections.length) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;

      var el = entry.target;
      var uid = el.id || el.getAttribute('data-si');
      if (fired.has(uid)) return;
      fired.add(uid);

      var sectionIndex = allSections.indexOf(el) + 1; // 1-indexed position on page
      var sectionId    = (el.id || '').replace(/^shopify-section-/, '');
      var sectionLabel = getSectionLabel(el);

      var docH = document.documentElement.scrollHeight - window.innerHeight;
      var scrollPct = docH > 0 ? Math.round((window.scrollY / docH) * 100) : 0;

      // Push to GTM dataLayer ?????????????????????????????
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event:          'section_viewed',
        section_name:   sectionLabel,
        section_id:     sectionId,
        section_index:  sectionIndex,
        page_type:      pageType,
        scroll_percent: scrollPct
      });
    });
  }, {
    threshold: 0.25   // fires when 25% of section is visible
  });

  allSections.forEach(function (section, i) {
    // Fallback uid for sections without an id
    if (!section.id) section.setAttribute('data-si', 'section-' + i);
    observer.observe(section);
  });

})();
